import React from "react";
import { useNavigate } from "react-router";

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col justify-center items-center h-screen bg-bg-subtle select-none">
      <span className="font-mono text-[120px] leading-none font-semibold text-fg-bold tracking-tight">
        404
      </span>
      <p className="mt-4 text-base text-fg-medium">
        This page wandered off the map
      </p>
      <button
        onClick={() => navigate("/overview")}
        className="mt-8 px-4 py-2 text-xs font-medium text-fg-bold bg-bg border border-border rounded-sm hover:bg-bg-hover transition-colors duration-100 cursor-pointer"
      >
        Back to models
      </button>
    </div>
  );
};
